import { render } from "./AdminUserList.vue?vue&type=template&id=70fad061&scoped=true"
import script from "./AdminUserList.vue?vue&type=script&lang=js"
export * from "./AdminUserList.vue?vue&type=script&lang=js"

import "./AdminUserList.vue?vue&type=style&index=0&id=70fad061&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fad061"]])

export default __exports__